<template>
	<div class="SmartAvatar">
		<a-avatar v-if="$attrs.src" v-bind="$attrs" />
		<a-avatar v-else v-bind="$attrs">
			<template #icon>
				<UserOutlined />
			</template>
		</a-avatar>
	</div>
</template>
<script setup name="SmartAvatar"></script>
<style scoped lang="less">
	.SmartAvatar {
		.ant-avatar {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}
	}
</style>
